import { useContext } from 'react';
import AppLayout from './layout/app';
import UserProfile from './components/account/userProfile';
import ChangePassword from './components/account/changePassword';
import Login from './components/account/login/login';
import UseCheckToken from './components/account/login/useCheckToken';
import ForgotPassword from './components/account/login/forgotPassword';
import ResetPassword from './components/account/login/resetPassword';
import Logout from './components/account/logout';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Products from './components/settings/products/products';
import Components from './components/settings/components/components';
import Modules from './components/settings/modules/modules';
import Users from './components/settings/users/users';
import Vendors from './components/settings/vendors/vendors';
import DialogContainer from './dialogs/dialogContainer';
import Matrixs from './components/matrix/matrixs';
import MatrixDetail from './components/matrix/matrixDetail';
import Tests from './components/tests/tests';
import TestDetail from './components/tests/testDetail';
import Configurations from './components/settings/configurations/configurations';
import { MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { LoadingApp } from './control/loadingApp';
import Notifications from './components/notifications/notifications';
import ToastAppMsg from './components/notifications/toastAppMsg';
import { ToastAppType } from './common/constant/enum/toastAppType';
import globalAxios from 'axios';
import { ToastAppMsgContext } from './context/toastApp.Context';
import Product from './components/products/product';
import ProductDetail from './components/products/productDetail';

const App = ({ instance }: { instance: IPublicClientApplication }) => {
  const { setToastData } = useContext(ToastAppMsgContext);
  const { tokenCheck } = UseCheckToken();

  const requestHandler = (request: any) => {
    if (localStorage.Token) {
      const userToken = JSON.parse(localStorage.Token);
      if (userToken && userToken.Token && tokenCheck && tokenCheck != userToken.Token) {
        window.location.href = '/matrix';
      }
      request.headers['Authorization'] = 'Bearer ' + userToken.Token.toString();
    }
    return request;
  };
  const responseHandler = (response: any) => {
    return response;
  };
  globalAxios.interceptors.request.use((request) => requestHandler(request));
  globalAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (err) => {
      if (err.response && err.response.status === 401) {
        window.location.href = '/login';
      } else {
        if (err.response.config.url.indexOf('LoginFromAzure') < 0) {
          err.response.data.Messages &&
            err.response.data.Messages.map((item: any) => {
              setToastData({ Message: item as string, Type: ToastAppType.Error });
            });
        }
      }
      if (err.response.config.url.indexOf('LoginFromAzure') > 0) {
        return err.response;
      }
      return err;
    },
  );
  return (
    <>
      <BrowserRouter>
        <MsalProvider instance={instance as IPublicClientApplication}>
          <Switch>
            <Route path="/logout" render={() => <Logout></Logout>} />
            <Route path="/login" render={() => <Login></Login>} />
            <Route path="/forgotpassword" exact render={() => <ForgotPassword></ForgotPassword>} />
            <Route path="/reset-password" exact render={() => <ResetPassword></ResetPassword>} />
            <AppLayout>
              <Route path="/userprofile" exact render={() => <UserProfile></UserProfile>} />
              <Route path="/changepassword" exact render={() => <ChangePassword></ChangePassword>} />
              <Route path="/products" exact render={() => <Product></Product>} />
              <Route path="/products/detail/:id" exact render={() => <ProductDetail></ProductDetail>} />
              <Route path="/tests" exact render={() => <Tests></Tests>} />
              <Route path="/tests/:modelId/:productTypeId" exact render={() => <Tests></Tests>} />
              <Route path="/test/detail/:id" exact render={() => <TestDetail></TestDetail>} />
              <Route path="/matrix" exact render={() => <Matrixs></Matrixs>} />
              <Route path="/matrix/detail/:id/:module?" exact render={() => <MatrixDetail></MatrixDetail>} />
              <Route path="/settings/components" render={() => <Components></Components>} />
              <Route path="/settings/products" render={() => <Products></Products>} />
              <Route path="/settings/modules" render={() => <Modules></Modules>} />
              <Route path="/settings/vendors" render={() => <Vendors></Vendors>} />
              <Route path="/settings/users" render={() => <Users></Users>} />
              <Route path="/settings/configurations" render={() => <Configurations></Configurations>} />
              <Notifications></Notifications>
            </AppLayout>
          </Switch>
        </MsalProvider>
      </BrowserRouter>
      <DialogContainer></DialogContainer>
      <LoadingApp></LoadingApp>
      <ToastAppMsg></ToastAppMsg>
    </>
  );
};
export default App;
